module.exports = Object.freeze({
  REST_URL: process.env.REACT_APP_REST_URL,
  IPFS_URL: process.env.REACT_APP_IPFS_URL,
  WEBSITE_URL: process.env.REACT_APP_WEBSITE_URL,
  NETWORK_ID: process.env.REACT_APP_NETWORK_ID
});
